import { render, staticRenderFns } from "./aistadium.vue?vue&type=template&id=2d43cf4a&"
import script from "./aistadium.vue?vue&type=script&lang=ts&"
export * from "./aistadium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports